<template>
	<div class="imgPlus">
		<div v-if="loading" class="imgPlusLoading">
			<div class="spinner">
				<div class="dot1"></div>
				<div class="dot2"></div>
			</div>
		</div>
		<a v-if="isPdf" :href="setFullImage" target="_blank" class="isPdf externalLink" aria-label="PDFをブラウザー別windowで閲覧する">
<!--		<a v-if="isPdf" @click.stop="previewPdf(setFullImage)" class="externalLink">-->
<!--
			<pdf v-if="isPdf" :src="setAnyImage" :alt="imgAlt" :data-image="setFullImage" role="button" v-on:loaded="imgLoaded" v-on:error="imgLoadError"></pdf>
-->
			<pdf :src="setAnyImage" :alt="imgAlt" :data-image="setFullImage" role="button"></pdf>
		</a>

		<a v-else-if="isMov" href="javascript:void(0);" class="isMov" :class="{cursorZoomIn:fullScreen}" @click.stop="openOverView($event, fullScreen)" @keyup.enter.stop="openOverView($event, fullScreen)" :data-image="setVideo" aria-label="フルスクリーンで映像を見る">
		<video autoplay loop muted playsinline :src="setVideo" type="video/mp4" :poster="setAnyImage"  :alt="imgAlt" area-label="映像" v-on:loadstart="imgLoadStart" v-on:loadeddata="imgLoaded" v-on:error="imgLoadError" v-on:playing="videoPlaying"></video>
		</a>
<!--
		<video v-else-if="isMov" autoplay loop muted playsinline :src="setVideo" :data-image="setVideo" type="video/mp4" :poster="setAnyImage"  :alt="imgAlt"  @click.stop="openOverView($event, fullScreen)" area-label="映像" v-on:loadstart="imgLoadStart" v-on:loadeddata="imgLoaded" v-on:error="imgLoadError"></video>
-->
		<a v-else href="javascript:void(0);" class="isImage" :class="{cursorZoomIn:fullScreen}" @mouseenter="moving" @mouseleave="stopped" @focus="moving" @blur="stopped" @click.stop="openOverView($event, fullScreen)" @keyup.enter.stop="openOverView($event, fullScreen)" :data-image="setFullImage" aria-label="フルスクリーンで画像を見る">
			<img :src="setAnyImage" :alt="setAlt" :width="imgWidth" :height="imgHeight" area-label="画像" v-on:load="imgLoaded" v-on:error="imgLoadError" ref="imgTag">
		</a>
<!--
		<img v-else :src="setAnyImage" :alt="setAlt" :data-image="setFullImage" @mouseenter="moving" @mouseleave="stopped" role="button" tabIndex={0} @click.stop="openOverView($event, fullScreen)" :class="{cursorZoomIn:fullScreen}" :width="imgWidth" :height="imgHeight" area-label="画像" v-on:load="imgLoaded" v-on:error="imgLoadError" ref="imgTag">
-->


	</div>
</template>

<script>
/*src指定がpdfの場合、vue-pdfを利用して処理するようにする*/
import pdf from 'vue-pdf'

/*
表示画像セットについて
表示元がリスト内か単体かによって対応を変える。
リストの場合は、映像でもサムネイル画像をセット
単体表示では、サムネイル指定がない場合は、オリジン画像をセットする
ともに指定画像がない場合は、[noImage]をセットする

拡大表示用画像セットについて
オリジン画像をセットする
画像指定がない場合は、""をセットする
*/

export default {
  name: 'imgPlus',
  props: {
    imgSrc:{ //
      type:String,
      default:"",
    },
    imgAlt:{
      type:String,
      default:"",
    },
		imgThumb: { //サムネイル 映像ではposter要素
			type:String,
			default:"",
		},
		fullScreen:{ //拡大機能：true > on,  false > off
			type:Boolean,
		},
		atPlace:{ //使用箇所： "single", "list"
			type:String,
			default:"single",
		},
		getOutside:{ //使用箇所： "out", ""
			type:String,
			default:"",
		},
  },
  components:{
    pdf,
  },
  data() {
    return {
			loading:false,
			imgWidth:0,
			imgHeight:0, 
    }
  },
  computed:{
    isPdf:function() {
      return this.imgSrc != null && this.imgSrc.toLowerCase().indexOf(".pdf") !== -1
    },
    isMov:function() {
      return this.imgSrc != null && this.imgSrc.toLowerCase().indexOf(".mp4") !== -1 //&& (this.atPlace == "single" )
    },
/*表示イメージURLセット*/
		setAnyImage:function() {
//			let aImage = require("@/asset/images/noImage.svg")

			let aImage = "pages/noImage.svg"
			if(this.atPlace == "list") {		//リスト表示の場合
				if((this.imgThumb != "")&&(this.imgThumb != null))  {				//サムネイルをsrcにセットする
					aImage = this.imgThumb
				} else if((this.imgSrc != "" )&&(this.imgSrc != null) ){   //サムネイル指定がない場合、オリジンをsrcにセットする
					aImage = this.imgSrc
				} else {																	//オリジンの指定もない場合、[noImage]をセットする
				}
			} else {                                 //単体表示の場合
				if((this.imgSrc != "" )&&(this.imgSrc != null) ){
					aImage = this.imgSrc         //オリジンをsrcにセットする
				}
			}

//out指定の場合は、サーバー格納位置を足さない
			if(this.getOutside == "out") {
				aImage = aImage
//noImageはinstagramの場合はない
			} else {
				aImage = this.setImageFullPath(aImage)
			}
this._log(aImage)
			return aImage
		},
/*拡大イメージURLセット*/
		setFullImage:function() {
			let aImage = ""
			if((this.imgSrc != "" )&&(this.imgSrc != null )) {         //リスト、単体関係なくあればオリジンをsrcにセットする
				aImage = this.setImageFullPath(this.imgSrc)
			}
			return aImage
		},
		setAlt:function() {
			let aAlt = "no image"
			if((this.imgAlt != "")&&(this.imgAlt != null))  {
				aAlt = this.imgAlt
			}
			return aAlt
		},
/*映像は、srcにそのままセットする*/
		setVideo:function() {
			//out指定の場合は、サーバー格納位置を足さない
			return this.getOutside == "out"?this.imgSrc:this.setImageFullPath(this.imgSrc)
		},
/*映像の場合 posterをセットする*/
		setPoster:function() {
				return this.setImageFullPath(this.imgThumb)
		},
		overViewEnable() {
				return this.fullScreen
		},
  },
  watch: {
/*コンポーネント再利用時の監視 ページ切り替え時にイニシャルをする*/
/*
		imgSrc: {
      handler(newData, oldData) {
//this._log("CHANGED")
        if (oldData !== newData) {
					this.loading=true
        }
      },
		},
*/
	},
  created:function() { this._log("created "+this.$options.name)
  },
  beforeUpdate:function() {this._log("beforeUpdate "+this.$options.name)
	},
  updated: function() {this._log("updated "+this.$options.name)
	},
  methods:{
    moving:function(e) {
      e.target.classList.add("expansion")
    },
    stopped:function(e) {
      e.target.classList.remove("expansion")
    },
    takeFileName:function(aUrl) {
      return aUrl.match(".+/(.+?)([?#;].*)?$")[1]
    },
    innerImage:function(aUrl) {
      return require(aUrl)
    },
		imgLoadStart:function(e) {
this._log("imgLoadedStart", e.target)
			this.loading=true
		},
		videoPlaying:function(e) {
this._log("videoPlaying", e.target)
			this.loading=false
		},
		imgLoaded:function(e) {
this._log("imgLoadedX", e.target)

		this.imgWidth = e.target.naturalWidth
		this.imgHeight = e.target.naturalHeight

this._log(this.imgWidth)

			this.loading=false
    },
		imgLoadError:function(e) {
this._log("imgLoadError", e.target)
			this.loading=true
		},

		previewPdf(aUrl) {
//pdfプラグインは、タグ情報を継承しないためクリック操作が無効
//上の階層でクリックを処理する必要がある
this._log("OPEN WINDOW")
			window.open(aUrl, '_blank')
		},
  },
}
</script>

<style scoped>
</style>